import { configureStore } from '@reduxjs/toolkit';
import webpageReducer from './Slice/webPageSlice';

export const store = configureStore({
  reducer: {
    webpageState: webpageReducer,
  },
});

// Infer types for root state and dispatch
export type IRootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
